module.exports = __webpack_public_path__ + "media/images/delivery_cart-b3f6e736.png";